import "@fontsource/poppins"; // Defaults to weight 400.

const styles = {
  global: (props: any) => ({
    // styles for the `body`
    body: {
      bg: props.colorMode === "dark" ? "#161618" : "#F7FAFB",
      fontSize: "16px"
    },
    // styles for the `a`
    a: {
      color: "teal.500",
      _hover: {
        textDecoration: "underline"
      }
    }
  })
};

export default styles;
